import { Product } from '@nemuru-eng/js-api-client';

export enum ProductSelectOption {
  CONSUMER_LOAN = Product.CONSUMER_LOAN,
  AUTO = Product.AUTO,
  CREDIT_LINE = Product.CREDIT_LINE,
  CARD = Product.CARD,
}
